import { useNavigate } from "react-router";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { formatDuration } from "@/utils/format/date-time";

export const ServiceCard = ({ clinician, service, params }) => {
    const serviceTypes = service.serviceTypeTitles.split(",");

    const navigate = useNavigate();

    const onBook = (clinician, service, params) => {
        navigate("/clinicians/book", {
            state: { clinician, service, params },
        });
    };

    return (
        <Card className="flex h-full flex-col p-6 text-sm md:col-span-6 md:flex-row">
            <div className="flex-1 space-y-2">
                <p className="mb-1 text-xl font-medium">
                    {service.serviceTitle}
                </p>
                <p className="line-clamp-2">{service.serviceDescription}</p>
                <div className="flex flex-wrap gap-x-4 gap-y-2">
                    <p>
                        <span className="text-base/6 text-neutral-500">
                            Duration:{" "}
                        </span>
                        <span className="font-medium">
                            {formatDuration(service.appointmentLength)}
                        </span>
                    </p>
                </div>
                <div>
                    <div className="flex flex-wrap gap-2">
                        <p className="w-full font-medium">Service types:</p>
                        {serviceTypes.map((type, index) => (
                            <Badge key={index} variant="secondary">
                                {type}
                            </Badge>
                        ))}
                    </div>
                </div>
            </div>
            <div className="ms-auto mt-auto flex flex-col flex-wrap justify-end gap-3 text-end">
                <p className="text-2xl font-bold">
                    £{Number(service.appointmentPrice).toFixed(2)}{" "}
                    <span className="text-sm font-medium text-neutral-500">
                        per session
                    </span>
                </p>
                <Button
                    type="button"
                    variant="primary"
                    className="ms-auto"
                    onClick={() => onBook(clinician, service, params)}
                >
                    Book appointment
                </Button>
            </div>
        </Card>
    );
};
